import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const sample = [{'user':'A','msg': "I'm a large language model, I don't have access to real-time weather information, but I can provide general information about the weather or help you find out the current weather conditions in your area."},{'user':'B','msg': "That's correct! I'm glad we can adapt."},{'user':'A','msg': 'Me too!'},{'user':'B','msg': "Let's keep chatting!"},{'user':'A','msg': "Sounds like fun! What's on your mind?"},{'user':'B','msg': "I'm happy to chat about anything you'd like!"},{'user':'A','msg': "Let's play a game: I'll give you a random topic, and you tell me the first word that comes to your mind. ready? Okay, the topic is... Travel!"},{'user':'B','msg': 'Passport!'},{'user':'A','msg': "What a great choice!\n\nNext topic: Movie! What's the first word that comes to your mind?"},{'user':'B','msg': 'Hollywood!'}]
export default function LlmABConversations() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [conversation, setConversation]= useState(sample)
    const [userInput, setUserInput] = useState({'first-msg':"How is today's weather?"})
    const onChange2Input=({currentTarget:x})=>{setUserInput({...userInput,[x.name]:x.value})}
    const onClick2GenScript=async()=>{
        setLoadingMsg(true)
        try {
            const {data:res}=await axios.post(`${APIURL}/llm/abconversation`,userInput)
            console.log('ab response:',res)
            setLoadingMsg(false)
            setConversation(res)
        } catch (err) {
            console.log(err)
        }
    }
      return (
        <>
        <div className='mt-[2px] flex'>
        <input className='pl-[2px] border border-gray-800 w-full md:w-[170px] mr-[2px] text-[9px]' name='first-msg' type='text' defaultValue="How is today's weather?" onChange={onChange2Input}/>
        <button disabled={loadingMsg} className={`hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-auto pl-[8px] pr-[8px] text-white text-[9px]`} onClick={onClick2GenScript}>Generate Conversations</button>
        </div>
        {loadingMsg?<p className='flex text-[9px]'>Please wait for 5seconds<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:<div className='text-left'>
        {conversation.map(x=><p className='text-[9px]'>{x.user}:{x.msg}</p>)}
       </div>}
       </>
      )
}